export const ERROR = 'error';
export const SUCCESS = 'success';
export const WARNING = 'warning';
export const INFO = 'info';



// WEBPACK FOOTER //
// ./src/app/alerta/message.resource.ts